module.exports = __webpack_public_path__ + "img/larry_the_lobster.9b15f426.jpg";